import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { collection, getDocs } from "firebase/firestore";

import { db } from "../firebase";

import "./Courses.css";

function Courses() {
  const { t, i18n } = useTranslation();

  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  const isArabic = i18n.language === "ar";

  useEffect(() => {
    const loadCourses = async () => {
      try {
        const snapshot = await getDocs(
          collection(db, "courses")
        );

        const data = snapshot.docs.map((item, index) => ({
          id: item.id,
          number: String(index + 1).padStart(2, "0"),
          ...item.data(),
        }));

        setCourses(data);
      } catch (error) {
        console.error("Courses Error:", error);
      } finally {
        setLoading(false);
      }
    };

    loadCourses();
  }, []);

  return (
    <main className="courses-page">

      {/* ================= HERO ================= */}

      <section className="courses-hero">

        <div className="courses-hero-content">

          <span className="courses-tag">
            {t("courses.tag")}
          </span>

          <h1>
            {t("courses.title")}
          </h1>

          <p>
            {t("courses.intro")}
          </p>

        </div>

      </section>


      {/* ================= COURSES ================= */}

      <section className="courses-section">

        <div className="courses-heading">

          <div>

            <span className="section-label">
              {t("courses.programsTag")}
            </span>

            <h2>
              {t("courses.programsTitle")}
            </h2>

          </div>

          <p>
            {t("courses.programsText")}
          </p>

        </div>


        {/* LOADING */}

        {loading && (
          <div className="courses-loading">
            جاري تحميل الدورات...
          </div>
        )}


        {/* NO COURSES */}

        {!loading && courses.length === 0 && (
          <div className="courses-empty">
            لا توجد دورات متاحة حالياً.
          </div>
        )}


        {/* COURSES GRID */}

        {!loading && courses.length > 0 && (

          <div className="courses-grid">

            {courses.map((course) => (

              <article
                className="course-card"
                key={course.id}
              >

                {/* IMAGE */}

                {course.image && (
                  <div className="course-image-wrapper">

                    <img
                      src={course.image}
                      alt={
                        isArabic
                          ? course.titleAr
                          : course.titleEn
                      }
                      className="course-image"
                    />

                  </div>
                )}


                {/* TOP */}

                <div className="course-top">

                  <span className="course-number">
                    {course.number}
                  </span>

                  <span className="course-category">

                    {isArabic
                      ? course.categoryAr
                      : course.categoryEn}

                  </span>

                </div>


                {/* TITLE */}

                <h3>

                  {isArabic
                    ? course.titleAr
                    : course.titleEn}

                </h3>


                {/* DESCRIPTION */}

                <p>

                  {isArabic
                    ? course.descriptionAr
                    : course.descriptionEn}

                </p>


                {/* REGISTER */}

                <Link
                  to="/registration"
                  className="course-button"
                >

                  {t("courses.register")}

                  <span>
                    ←
                  </span>

                </Link>

              </article>

            ))}

          </div>

        )}

      </section>


      {/* ================= CTA ================= */}

      <section className="courses-cta">

        <div>

          <span>
            {t("courses.ctaTag")}
          </span>

          <h2>
            {t("courses.ctaTitle")}
          </h2>

          <p>
            {t("courses.ctaText")}
          </p>

        </div>

        <Link
          to="/registration"
          className="courses-cta-button"
        >
          {t("courses.ctaButton")}
        </Link>

      </section>

    </main>
  );
}

export default Courses;